module.exports = __webpack_public_path__ + "img/9788992844529.e08b7c4e.jpg";